import * as React from "react";
import { ExtraIconPro } from "../../../services/product";
import { LeftBottomTag, LeftTopTags, NewRightTopTag } from "./styles";
import { ImgType } from "utils/playground/product";

interface ProductImageTagViewsProps {
	columnNum: number;
	rightTopTag?: ExtraIconPro;
	leftTopTag?: ExtraIconPro;
	leftTopTag2?: ExtraIconPro;
	leftBottomTag?: ExtraIconPro;
	isOnlyShowLeftTopTag?: boolean;
	isShowFlashOrPromotion?: boolean;
}

export const ProductImageTagViews = (props: ProductImageTagViewsProps) => {
	const { rightTopTag, leftTopTag, leftTopTag2, leftBottomTag, isOnlyShowLeftTopTag, isShowFlashOrPromotion } = props;

	const returnLeftTopTag = () => {
		const flashEle = [leftTopTag, leftTopTag2].find((ele) => ele?.type === ImgType.FLASH_SALE);
		const promotion = [leftTopTag, leftTopTag2].find((ele) => ele?.type === ImgType.PROMOTION);
		if (flashEle) {
			return flashEle;
		} else if (promotion) {
			return promotion;
		} else if (leftTopTag && leftTopTag.img?.[0] && !isShowFlashOrPromotion) {
			return leftTopTag;
		} else if (leftTopTag2 && leftTopTag2.img?.[0] && !isShowFlashOrPromotion) {
			return leftTopTag2;
		}
	};

	const renderTags = () => {
		if (!isOnlyShowLeftTopTag) {
			return (
				<>
					{rightTopTag?.img && <NewRightTopTag src={rightTopTag?.img} />}
					{(leftTopTag?.img || leftTopTag2?.img) && (
						<LeftTopTags>
							{leftTopTag?.img && <img src={leftTopTag.img} />}
							{leftTopTag2?.img && <img src={leftTopTag2.img} />}
						</LeftTopTags>
					)}
				</>
			);
		} else {
			const showLetTag = returnLeftTopTag() || null;
			return (
				<>
					{showLetTag && showLetTag.img && (
						<LeftTopTags>
							<img src={showLetTag.img} />
						</LeftTopTags>
					)}
				</>
			);
		}
	};

	return (
		<div>
			{renderTags()}
			{leftBottomTag?.img && <LeftBottomTag src={leftBottomTag?.img} />}
		</div>
	);
};
